import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = new HttpLink({
  uri: process.env.NEXT_PUBLIC_GRAPHQL_URL || 'http://localhost:4000/graphql',
});

// Use URL path as source of truth so header always matches the page
// (follows the same pattern as the my.1099policy.com app)
const envLink = setContext((_, { headers }) => {
  let environment: string | undefined;
  if (typeof window !== 'undefined') {
    environment = window.location.pathname.startsWith('/sandbox/')
      ? 'sandbox'
      : (process.env.NEXT_PUBLIC_ENVIRONMENT || 'production');
  }
  if (!environment) {
    environment = process.env.NEXT_PUBLIC_ENVIRONMENT || 'production';
  }
  return {
    headers: {
      ...headers,
      'Ten99Policy-Environment': environment,
    },
  };
});

export const client = new ApolloClient({
  link: from([envLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
    },
    mutate: {
      fetchPolicy: 'no-cache',
    },
  },
});
